import { render, staticRenderFns } from "./AupairSponsorPostulations.vue?vue&type=template&id=1c0b8c89&"
import script from "./AupairSponsorPostulations.vue?vue&type=script&lang=js&"
export * from "./AupairSponsorPostulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports